import { orderBy } from 'lodash' // chain
import convert from '../../helpers/convert'

/*
 * PrepareFundHoldingLists
 * @params holdings<list>, fundholdings<list>
 * @return <object>
 *
 * Take list of holdings and fundholdings
 * For each of our six issues:
 * Filter the list of holdings so to just those relevant to the issue
 * e.g. that have an SJF score. or have an exclusion flag
 * sort these lists on market_value,
 * also take top and bottom 10 lists (for SJF holdings)
 *
 * return <object>:
 * {
 *   holdings<list>,
 *   top10<list>,
 *   bottom10<list>,
 * }
 */

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

const PrepareFundHoldingLists = {
  process: (holdings, fundholdings) => {
    // console.log('HI HERE PrepareFundHoldingLists')
    // console.log(holdings.length)
    // console.log(fundholdings.length)
    //
    const fHoldingsMap = mapFundHoldings(fundholdings)

    const scoreFieldDict = {
      gef_score: 'gef', dei_score: 'dei', rji_score: 'rji',
      hrc_score: 'hrc', is_pp: 'pff', is_mmc: 'wff',
    }

    const results = {}

    Object.keys(scoreFieldDict).map((scoreField, scoreFieldI) => {
      // filter to just scored holdings
      let eqHoldings = holdings.reduce((filtered, h) => {
        // copy over fundholding values
        h.market_value = convert.int(fHoldingsMap[h.id].market_value)
        h.long_weight = fHoldingsMap[h.id].long_weight

        let isReject = false

        const trueIfNull = (l) => {
          return (h[l] === null || h[l] === undefined)
        }

        // exclusion - pff
        if (['is_pp'].includes(scoreField)) {
          isReject = trueIfNull('is_pp') && trueIfNull('is_borders')
        }

        // exclusion - wff
        if (['is_mmc'].includes(scoreField)) {
          isReject = trueIfNull('is_mmc')
        }

        // sjf e&j
        if (['gef_score', 'dei_score', 'rji_score', 'hrc_score'].includes(scoreField)) {
        // if null, leave it, otherwise, convert to float
          h[scoreField] = h[scoreField] === null ? null : convert.float(h[scoreField])
          // set flags for removal
          const isUndefined = h[scoreField] === undefined
          const isNull = h[scoreField] === null
          const isNullSentinel = h[scoreField] === -1000 || h[scoreField] === '-1000'
          isReject = (isUndefined || isNull || isNullSentinel)
        }

        if (!isReject) {
          filtered.push(h)
        }
        return filtered
      }, [])

      eqHoldings = orderBy(eqHoldings, ['market_value'], ['desc'])
      const top10Holdings = orderBy(eqHoldings, [scoreField, 'market_value'], ['desc', 'desc']).slice(0, 10)
      const bottom10Holdings = orderBy(eqHoldings, [scoreField, 'market_value'], ['asc', 'desc']).slice(0, 10)

      results[scoreFieldDict[scoreField]] = {
        holdings: eqHoldings,
        top10: top10Holdings,
        bottom10: bottom10Holdings
      }
      //
      return false
    })
    //
    // console.log('HI HERE end of PrepareFundHoldingLists')
    // console.log(results)
    return results
  }
}

export default PrepareFundHoldingLists